<div mat-dialog-title>
    {{data.message}}
</div>
<div mat-dialog-content>
 <div [innerHTML]="data.content"></div>

</div>
<div mat-dialog-actions align="center">
    <button  mat-raised-button color="warn" [mat-dialog-close]="false">No</button>
    <button mat-raised-button color="primary" [mat-dialog-close]="true">Si</button>
</div>